"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prizeDrawPartitionSum = void 0;
const numbers_1 = require("../numbers");
function prizeDrawPartitionSum({ numberLength = 6 }) {
    let digits = [];
    let values = [];
    let tickets = 0;
    let winners;
    let digitChoice;
    // Generate the number of tickets
    for (let i = 0; i < numberLength; i++) {
        digits.push((0, numbers_1.integerBetween)({ minInt: 1, maxInt: 9 }));
        values.push(digits[i] * Math.pow(10, numberLength - 1 - i));
        tickets += values[i];
    }
    // Choose the number of winners
    do {
        digitChoice = (0, numbers_1.integerBetween)({ minInt: 1, maxInt: numberLength - 1 });
        winners = Math.pow(10, numberLength - 1 - digitChoice) * (0, numbers_1.integerBetween)({ minInt: 1, maxInt: 9 });
    } while (winners >= values[digitChoice] || winners < 2);
    const valuesMinusWinners = [...values];
    valuesMinusWinners[digitChoice] -= winners;
    return {
        digits,
        values,
        valuesMinusWinners,
        tickets,
        winners,
        digitChoice,
    };
}
exports.prizeDrawPartitionSum = prizeDrawPartitionSum;
